"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutocompleteSource = void 0;
const scrollable_source_hook_1 = require("../../utils/scrollable-source-hook");
const react_1 = require("react");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const crud_source_hook_1 = require("../../utils/crud-source-hook");
function useAutocompleteSource({ url, apiUrl, params, }) {
    const query = react_1.useRef('');
    const setSearchQuery = event_callback_hook_1.useEventCallback((q) => {
        query.current = q;
    });
    const getUrl = event_callback_hook_1.useEventCallback(() => {
        return `${url}?query=${encodeURIComponent(query.current)}`;
    });
    const loadDetail = event_callback_hook_1.useEventCallback(async (item) => {
        if (apiUrl !== undefined) {
            const fetch = crud_source_hook_1.defaultGetItem(apiUrl, item.id);
            const detail = await fetch.json();
            return detail;
        }
        return Promise.resolve(item);
    });
    const result = scrollable_source_hook_1.useScrollableSource({ url: getUrl, params });
    const source = react_1.useMemo(() => ({
        ...result,
        setSearchQuery,
        loadDetail,
    }), [result, setSearchQuery, loadDetail]);
    return source;
}
exports.useAutocompleteSource = useAutocompleteSource;
//# sourceMappingURL=autocomplete-source-hook.js.map